import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import BannerLoyalty from "components/BannerLoyalty";

const Loyalty = props => {
	const classes = useStyles();
	const { properties, infoShop, details = false, dataInfoLoyalty } = props;

	return (
		<React.Fragment>
			<BannerLoyalty
				properties={properties}
				currentSales={infoShop?.currentSales}
				achivedSales={properties.sales}
				nextLevel={properties.type}
				currentLevel={infoShop?.crmLevel}
				isInfo={false}
				levelAchieved={false}
				details={details}
				dataInfoLoyalty={dataInfoLoyalty}
			/>
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.rootHeader }}>Thưởng</Grid>
				<Grid classes={{ root: classes.text }}>
					<span className={classes.dot} /> Thưởng {properties?.bonus}{" "}
					trên tổng doanh số mua hàng các SP Cao Cấp, Trung Cấp, Phổ
					Thông vào cuối tháng.
				</Grid>
				<Grid classes={{ root: classes.rootHeader }}>Điều kiện</Grid>
				<Grid classes={{ root: classes.text }}>
					<span className={classes.dot} /> Mua hàng trong tháng ít
					nhất {properties?.numOfWeekPurchase} tuần, được tính khi mua
					hàng Cao Cấp, Trung Cấp, Phổ Thông.
				</Grid>
				<Grid classes={{ root: classes.text }}>
					{" "}
					<span className={classes.dot} />
					Mua đạt doanh số đặt ra.
				</Grid>
				<Grid classes={{ root: classes.text }}>
					{" "}
					<span className={classes.dot} />
					Phải duy trì doanh số mới được giữ hạng.
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default memo(Loyalty);
